import { actions, paths } from "../../../../common/constants";

export default {
  getPosts: ({
    asc = false,
    orderBy = "createdAt",
    limit = 10,
    start_at = 1,
    keyword,
    customer_id,
    deleted = "false",
    post_type,
  }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POST_ITEMS_REQUEST,
        actions.GET_POST_ITEMS_SUCCESS,
        actions.GET_POST_ITEMS_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.api.v2.POSTS, {
          asc,
          orderBy,
          limit,
          start_at,
          keyword,
          customer_id,
          deleted,
          post_type
        }),
    },
  }),

  getPostById: (id) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POST_ITEM_REQUEST,
        actions.GET_POST_ITEM_SUCCESS,
        actions.GET_POST_ITEM_FAILURE,
      ],
      promise: (client) => client.get(paths.build(paths.api.v1.POSTS_ID, id)),
    },
  }),

  getPostsByTrip: ({ trip_id }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POSTS_ITEM_BY_TRIP_REQUEST,
        actions.GET_POSTS_ITEM_BY_TRIP_SUCCESS,
        actions.GET_POSTS_ITEM_BY_TRIP_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.POSTS_BY_TRIP, { params: { trip_id } }),
    },
  }),

  getPostDetail: (id) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POST_ITEM_DETAIL_REQUEST,
        actions.GET_POST_ITEM_DETAIL_SUCCESS,
        actions.GET_POST_ITEM_DETAIL_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.build(paths.api.v1.POST_DETAIL, id)),
    },
  }),

  updatePost: (id, post) => {
    const query = new FormData();
    for (let key in post) {
      if (key === "mediaInfo") {
        for (let i = 0; i < post[key].length; i += 1)
          query.append(key, post[key][i]);
      } else query.append(key, post[key]);
    }

    return {
      [actions.CALL_API]: {
        types: [
          actions.POST_UPDATE_REQUEST,
          actions.POST_UPDATE_SUCCESS,
          actions.POST_UPDATE_FAILURE,
        ],
        promise: (client) =>
          client.put(paths.build(paths.api.v2.POSTS_ID, id), query),
      },
    };
  },

  deletePost: (id) => ({
    [actions.CALL_API]: {
      types: [
        actions.POST_DELETE_REQUEST,
        actions.POST_DELETE_SUCCESS,
        actions.POST_DELETE_FAILURE,
      ],
      promise: (client) =>
        client.delete(paths.build(paths.api.v1.POSTS_ID, id)),
    },
  }),

  getTopRatedPosts: ({ customer_id, limit }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POSTS_TOP_RATED_REQUEST,
        actions.GET_POSTS_TOP_RATED_SUCCESS,
        actions.GET_POSTS_TOP_RATED_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.POSTS_TOP_RATED, {
          params: { customer_id, limit },
        }),
    },
  }),

  getRecentPosts: ({ customer_id, limit }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POSTS_RECENT_REQUEST,
        actions.GET_POSTS_RECENT_SUCCESS,
        actions.GET_POSTS_RECENT_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.POSTS_RECENT, {
          params: { customer_id, limit },
        }),
    },
  }),

  getPendingPosts: ({ customer_id, limit }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POSTS_PENDING_REQUEST,
        actions.GET_POSTS_PENDING_SUCCESS,
        actions.GET_POSTS_PENDING_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.POSTS_PENDING, {
          params: { customer_id, limit },
        }),
    },
  }),
};



// WEBPACK FOOTER //
// ./client/react/Admin/actions/posts.js